import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { HttpClientModule } from "@angular/common/http";

import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NgbAlertModule } from "@ng-bootstrap/ng-bootstrap";
import { NgbCarouselModule } from "@ng-bootstrap/ng-bootstrap";

import { FooterComponent } from "./shared/footer/footer.component";
import { NavbarComponent } from "./shared/navbar/navbar.component";
import { HomeComponent } from "./pages/home/home.component";
import { CartComponent } from "./pages/cart/cart.component";
import { ProductComponent } from "./pages/product/product.component";
import { CheckoutComponent } from "./pages/checkout/checkout.component";
import { SliderComponent } from "./pages/home/components/slider/slider.component";
import { PromotionsComponent } from "./pages/home/components/promotions/promotions.component";
import { IndexComponent } from "./pages/index/index.component";
import { ProductListComponent } from "./pages/product-list/product-list.component";
import { CategoriesComponent } from "./pages/home/components/categories/categories.component";
import { LoadingComponent } from "./shared/loading/loading.component";
import { NumberMilesPipe } from "./core/pipes/numberMiles.pipe";
import { ToastrModule } from "ngx-toastr";
import { CategoriesLettersComponent } from './pages/home/components/categories-letters/categories-letters.component';
import { CategoriesModernComponent } from './pages/home/components/categories-modern/categories-modern.component';
import { CategoriesPersonComponent } from './pages/home/components/categories-person/categories-personal.component';
import { CategoryComponent } from './pages/home/components/categories-letters/components/category/category.component';
import { ProductItemLetterComponent } from './pages/home/components/categories-letters/components/product-item-letter/product-item-letter.component';
import { ProductItemPersonComponent } from './pages/home/components/categories-person/components/product-item-person/product-item-person.component';
import { ExtractDecimalPipe } from './core/pipes/extract-decimal.pipe';
import { CategoryModernComponent } from './pages/home/components/categories-modern/components/category-modern/category-modern.component';
import { CategoryPersonComponent } from './pages/home/components/categories-person/components/category-person/category-person.component';
import { ProductItemModernComponent } from './pages/home/components/categories-modern/components/product-item-modern/product-item-modern.component';
import { ScanComponent } from './pages/scan/scan.component';
import { ModalOrdersComponent } from './pages/home/components/modal-orders/modal-orders.component';

@NgModule({
  declarations: [
    AppComponent,
    NumberMilesPipe,
    FooterComponent,
    NavbarComponent,
    HomeComponent,
    CartComponent,
    ProductComponent,
    CheckoutComponent,
    SliderComponent,
    PromotionsComponent,
    IndexComponent,
    ProductListComponent,
    CategoriesComponent,
    LoadingComponent,
    CategoriesLettersComponent,
    CategoriesModernComponent,
    CategoriesPersonComponent,
    CategoryComponent,
    ProductItemLetterComponent,
    ProductItemPersonComponent,
    ExtractDecimalPipe,
    CategoryModernComponent,
    CategoryPersonComponent,
    ProductItemModernComponent,
    ScanComponent,
    ModalOrdersComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    NgbAlertModule,
    NgbCarouselModule,
    BrowserAnimationsModule, // required animations module
    ToastrModule.forRoot({
      timeOut: 3000,
      positionClass: "toast-top-right",
    }), // ToastrModule added
  ],
  providers: [],
  bootstrap: [AppComponent],
  entryComponents: [ModalOrdersComponent]
})
export class AppModule {}
